import { useState } from "react";
import { sessionService } from "../services/session.service";
import { storage } from "../storage/storage";

export function useSession(apiKey?: string, embedOrigin?: string) {
    const [sessionId, setSessionId] = useState<string | null>(
        sessionService.getStoredSessionId()
    );
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [apiKeyInvalid, setApiKeyInvalid] = useState(false);
    const [originNotAllowed, setOriginNotAllowed] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const createSession = async (clientId: string) => {
        setIsLoading(true);
        setError(null);
        setApiKeyInvalid(false);
        setOriginNotAllowed(false);
        setErrorMessage(null);
        try {
            const session = await sessionService.create({
                userAgent: navigator.userAgent,
                clientId,
            }, apiKey, embedOrigin);

            setSessionId(session.id);
            return session.id;
        } catch (e: any) {
            const status = e?.response?.status;
            const message = e?.response?.data?.message || e?.response?.data?.msg || "";
            if (status === 403) {
                setErrorMessage(message);
                if (/origin/i.test(message)) {
                    setOriginNotAllowed(true);
                } else {
                    setApiKeyInvalid(true);
                }
            } else if (status === 401) {
                setApiKeyInvalid(true);
            }
            setError(e?.message || "Erreur création session");
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    const clearSession = () => {
        setSessionId(null);
        storage.remove("sessionId");
    };

    return {
        sessionId,
        isLoading,
        error,
        errorMessage,
        apiKeyInvalid,
        originNotAllowed,
        createSession,
        clearSession,
    };
}
